export enum BENEFICIARY_TYPE {
	NOMINATED = 'NON BINDING',
	REVERSIONARY = 'REVERSIONARY',
	BINDING = 'BINDING',
}

export const TRUSTEE_DETERMINED = 'TrusteeDetermined';
